import { render, staticRenderFns } from "./CampaignStepTemplate.vue?vue&type=template&id=5abef35e&scoped=true"
import script from "./CampaignStepTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignStepTemplate.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CampaignStepTemplate.vue?vue&type=style&index=0&id=5abef35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abef35e",
  null
  
)

export default component.exports